module.exports = __webpack_public_path__ + "media/errors/404-financial-aid-ca4f6f67.png";